import { apiClient } from './apiClient';
import { authService } from './authService';

const getCompanyParam = () => {
  const companyId = authService.getCompanyId();
  return companyId ? `companyId=${companyId}` : '';
};

export const locationService = {
  // Get all locations
  async getLocations() {
    return apiClient.get(`/api/cmms/locations?${getCompanyParam()}`);
  },

  // Get locations by branch
  async getLocationsByBranch(branchId) {
    return apiClient.get(`/api/cmms/locations/branch/${branchId}?${getCompanyParam()}`);
  },

  // Get single location by ID
  async getLocationById(id) {
    return apiClient.get(`/api/cmms/locations/${id}?${getCompanyParam()}`);
  },

  // Create new location
  async createLocation(data) {
    // Transform frontend form data to match backend DTO
    const payload = {
      code: data.code,
      name: data.name,
      branchId: data.branchId ? parseInt(data.branchId) : null,
      parentLocationId: data.parentLocationId ? parseInt(data.parentLocationId) : null,
      type: data.type,
      address: data.address || null,
      city: data.city || null,
      state: data.state || null,
      country: data.country || null,
      postalCode: data.postalCode || null,
      latitude: data.latitude ? parseFloat(data.latitude) : null,
      longitude: data.longitude ? parseFloat(data.longitude) : null,
      timezone: data.timezone || null,
      description: data.description || null
    };
    return apiClient.post(`/api/cmms/locations?${getCompanyParam()}`, payload);
  },

  // Update location
  async updateLocation(id, data) {
    // Transform frontend form data to match backend DTO
    const payload = {
      code: data.code,
      name: data.name,
      branchId: data.branchId ? parseInt(data.branchId) : null,
      parentLocationId: data.parentLocationId ? parseInt(data.parentLocationId) : null,
      type: data.type,
      address: data.address || null,
      city: data.city || null,
      state: data.state || null,
      country: data.country || null,
      postalCode: data.postalCode || null,
      latitude: data.latitude ? parseFloat(data.latitude) : null,
      longitude: data.longitude ? parseFloat(data.longitude) : null,
      timezone: data.timezone || null,
      description: data.description || null,
      isActive: data.isActive !== undefined ? data.isActive : true
    };
    return apiClient.put(`/api/cmms/locations/${id}?${getCompanyParam()}`, payload);
  },

  // Delete location
  async deleteLocation(id) {
    return apiClient.delete(`/api/cmms/locations/${id}?${getCompanyParam()}`);
  },
};
